var DK = DK || {};
DK.Giftcard = {
  /**
   * Initialize all the events for the giftcard page
   */
  initGiftcardEvents: function () {
    // Add event listener for check balance button
    $('#giftcard-check-balance').on('submit', function (e) {
      e.preventDefault();
      DK.Giftcard.clearFeedback($(this));
      DK.Giftcard.checkBalance($(this));
    });

    // Add event listener for giftcard type dropdown
    $('[name="gctype"]').on('change', function () {
      const $form = $(this).parents('form');
      DK.Giftcard.changeGiftcardType($(this).val(), $form);
    });

    // Add event listener for custom amount input
    $('#amount-custom').on('input', function () {
      $('[name="amt-check"]').not(this).prop('checked', false);
    });

    // Add event listener for radio buttons
    $('.btn-check[name="amt-check"]').on('change', function (e) {
      let thisValue = $(e.currentTarget).val();
      $('#amount').val(thisValue);
    });

    // Add event listener for buttons that trigger custom amount input
    $('.giftcard-buy__amt-btn').on('click tap', function () {
      $('#amount-custom').removeClass('is-invalid').siblings('.invalid-feedback').text('');
      $('#amount-custom').val('').trigger('change');
    });

    // Add event listener for formatting currency inputs
    $("input[data-type='currency']").on({
      keyup: function () {
        DK.formatCurrency($(this));
      },
      blur: function () {
        DK.formatCurrency($(this), "blur");
        let formattedValue = DK.Giftcard.stripCurrency($(this));
        if (!isNaN(formattedValue)) {
          $('#amount').val(formattedValue);
        } else {
          return;
        }
      }
    });

    // Add event listener for submit purchase form
    $('#giftcard-buy-form').on('submit', function (e) {
      e.preventDefault();
      DK.Giftcard.submitPurchase($(this));
    });

    // Add event listener for changing primary image on click
    $('.giftcard-buy__thumb-item').on('click tap', function () {
      let thumbSrc = $(this).children().attr('src');
      DK.Giftcard.changePrimaryImage(thumbSrc);
    });

    // Add event listener for switching back to the main primary image on resize
    $(window).on('resize', function () {
      $(window).breakpoints('lessThan', 'md', function () {
        let originalPrimaryImage = $('.giftcard-buy__thumb-item:first-of-type img').attr('src'),
          currentPrimaryImage = $('.giftcard-buy__primary-img img').attr('src');
        if (originalPrimaryImage !== currentPrimaryImage) {
          DK.Giftcard.changePrimaryImage(originalPrimaryImage);
        }
      });
    });
  },
  /**
   * Submits the gift card balance check form
   * @param {jQuery} $form object of the form
   */
  checkBalance: function ($form) {
    const giftcardBalanceModal = $('#giftcard-balance-modal');
    const resultsElement = giftcardBalanceModal.find('.modal-body');
    const spinner = new Spinner();
    const url = $form.attr('action');
    const formData = $form.serializeArray();

    // Before sending the AJAX request, display a loading spinner
    $.ajax({
      method: 'POST',
      data: formData,
      url,
      timeout: 12000,
      beforeSend: () => {
        DK.displayBlocker('body');
        spinner.spin($('body').get()[0]);
      }
    }).done(data => {
      if (data.status === 'error') {
        DK.Giftcard.invalidFeedback(data, giftcardBalanceModal[0]);
      } else {
        DK.Giftcard.updateCheckBalanceModal(data, giftcardBalanceModal);
        bootstrap.Modal.getOrCreateInstance(giftcardBalanceModal[0]).show();

        // Reset the form after a successful submission
        $form.trigger('reset');
      }
    }).fail(() => {
      resultsElement.empty().append('Something went wrong, please try again.');
      bootstrap.Modal.getOrCreateInstance(giftcardBalanceModal[0]).show();
    }).always(() => {
      // Hide the loading spinner after the AJAX request is complete
      DK.hideBlocker('body');
      spinner.stop();
    });
  },
  updateCheckBalanceModal: function (data, $modal, error) {
    if (error) {
      // update the modal with the generic error
      $modal.find('.giftcard-cb-modal-errors').removeClass('d-none').html(error);
      $modal.find('.giftcard-cb-modal').addClass('d-none');
    } else {
      // Update the modal with the gift card number and balance
      $modal.find('.giftcard-cb-modal').removeClass('d-none');
      $modal.find('.giftcard-cb-modal-errors').addClass('d-none');
      const balanceElement = $modal.find('.giftcard-cb-modal__balance');
      balanceElement.text('$' + data.balance);
    }
  },
  invalidFeedback: function (data, modalElement) {
    // Display inline validation errors
    data.errors.forEach(error => {
      if (error.field) {
        // handle field-specific errors
        const $fieldElement = error.field === 'amt' ? $('#amount-custom') : $(`#${error.field}`);
        $fieldElement.addClass('is-invalid');
        $fieldElement.siblings('.invalid-feedback').text(error.error);
      } else if (modalElement) {
        // generic errors are displayed in the modal
        DK.Giftcard.updateCheckBalanceModal(data, $(modalElement), error.error);
        bootstrap.Modal.getOrCreateInstance(modalElement).show();
      }
    });
  },
  resetInvalidFeedback: function ($form) {
    // Clear the form validation
    $form.find('.is-invalid').removeClass('is-invalid');
    $form.find('.invalid-feedback').text('');
  },
  clearFeedback: function ($form) {
    // Clear the form validation
    $form.find('.is-invalid').removeClass('is-invalid');
    $form.find('.invalid-feedback').text('');
  },
  changeGiftcardType: function (gcType, $form) {
    const skuIdInput = $form.find('[name="skuId"]');

    /**
     * Update the skuId input based on the gift card type
     * @param {string} gcType - The type of gift card, either 'physical' or 'virtual'
     */
    switch (gcType) {
      case 'physical':
        // Update the skuId to the physical gift card sku
        skuIdInput.val('GCPHYSICAL');
        // Update the gift card type
        $form.attr('data-gc-type', 'physical');
        // Hide the virtual gift card options
        $form.find('.giftcard-buy_opts--virtual').hide();
        // Show the shipping options section
        $form.find('.giftcard-buy__opt-section--shipping').show();
        break;
      case 'virtual':
        // Update the skuId to the virtual gift card sku
        skuIdInput.val('GCVIRTUAL');
        // Update the gift card type
        $form.attr('data-gc-type', 'virtual');
        // Show the virtual gift card options
        $form.find('.giftcard-buy_opts--virtual').show();
        // Hide the shipping options section
        $form.find('.giftcard-buy__opt-section--shipping').hide();
        break;
    }
  },
  /**
   * Submits the purchase form via AJAX
   * @param {jQuery} $form - The form element to be submitted
   */
  submitPurchase: function ($form) {
    const formAction = $form.attr('action');
    const gcType = $form.data('gcType');
    const cartPage = window.location.pathname === '/cart';
    DK.Giftcard.resetInvalidFeedback($form);

    // Submit the form via AJAX
    $.ajax({
      url: `${formAction}/${gcType}`,
      data: $form.serialize(),
      beforeSend: () => DK.displayBlocker('body') // Show the loading spinner
    }).done(data => {
      // If the request is successful and the page is the cart page
      if (cartPage) {
        let $modal = $('#gc-modal');
        // Update the cart detail section
        DK.Cart.updateDetailSection(data.orderDetails);

        // Update the cart totals
        DK.Cart.updateCart(data);

        // Hide the modal
        bootstrap.Modal.getInstance($modal[0]).hide();

        // Update the header cart
        DK.Cart.updateHeaderCart(data);
        DK.Cart.fixProductDescriptions();
      } else {
        // If the request is successful, but not on the cart page
        if (data.status === 'error') {
          // Show the validation error messages
          DK.Giftcard.invalidFeedback(data);
        } else {
          // Show the 'Added to Cart' modal
          $('#added-to-cart-modal').replaceWith(data.cartModalHtml);
          bootstrap.Modal.getOrCreateInstance(document.querySelector('#added-to-cart-modal')).show();

          // Update the header cart
          $('#cart-header').replaceWith(data.cartHeaderHtml);
          $('.cart-message').text(data.cartItemsCount);
        }
      }
    }).fail(jqXHR => {
      // Get the validation error messages from the response
      const errorMessages = jqXHR.responseJSON || [];

      // If there are validation error messages, show them
      DK.Giftcard.invalidFeedback(errorMessages);
    }).always(() => DK.hideBlocker('body')); // Hide the loading spinner
  },
  stripCurrency: function (input) {
    //Strip currency of any non-numeric characters
    return parseFloat(input.val().replace(/[^0-9.]/g, ''));
  },
  changePrimaryImage: function (thumbnail) {
    let newImg = $('<img>').attr('src', thumbnail);
    $('.giftcard-buy__primary-img').empty().append(newImg);
  }
};
DK.Giftcard.initGiftcardEvents();